import React from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";

export default function Training({ training, link }: any) {
  return (
    <Link
      to={`/${link}/${training?._id}`}
      className="border border-gray-300 mb-1 bg-white flex text-sm"
    >
      <div className="p-2 flex flex-col justify-center items-center bg-white w-44">
        <div className="">
          <Moment format="Do MMM, YYYY">{training?.start}</Moment>
        </div>
        <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
        <div className="h-10 bg-gray-300 border-r-2 border-gray-300"></div>
        <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
        <div className="">
          <Moment format="Do MMM, YYYY">{training?.end}</Moment>
        </div>
      </div>
      <div className="flex justify-between w-full">
        <div className="border-l p-2 bg-gray-50 flex-1">
          <div className="text-lg border-b pb-2 text-blue-900">
            <span className="font-bold">Training : </span>
            {training?.title}
          </div>
          <div className="py-1 text-lg italic">
            Organizer : {training?.organizer[0]?.name || "-"}
          </div>
          <div className="text-gray-600">
            Start Date: <Moment format="Do MMM, YYYY">{training?.start}</Moment>
          </div>
          <div className="text-gray-600">
            End Date: <Moment format="Do MMM, YYYY">{training?.end}</Moment>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center px-8">
          <div className="text-3xl">{training?.enrolled?.length}</div>
          <div className="">Attendee(s)</div>
        </div>
      </div>
    </Link>
  );
}
